import { RootState } from '@/store';
import { ActionContext, ActionTree } from 'vuex';
import { AuthorizationState } from '@/store/modules/authorization';
import { LOGOUT_WS } from '@/types/authorization.types';
import AuthorizationService from '@/services/authorization.service';
import { eventsHub } from '@/main';
import { AUTHENTICATION_ROOT, GOV } from '@/types/authentication.types';
import { RESET_STORE } from '@/types/store.types';

const authorizationService = new AuthorizationService();

export const actions: ActionTree<AuthorizationState, RootState> = {

  [LOGOUT_WS]: (
    { rootGetters, dispatch }: ActionContext<AuthorizationState, RootState>,
  ) => {
    authorizationService.logout()
      .subscribe(
        () => {
          dispatch(RESET_STORE, {}, { root: true });
          const loginRouting = rootGetters[AUTHENTICATION_ROOT + GOV] ? 'login?c=gov' : 'login';
          eventsHub.$router.push({ path: '/' + loginRouting });
        },
      );
  },

};
